import {
  FETCH_COMPANY_FEATURED_LOGOS,
  FETCH_PROMOTED_SPONSORED_JOBS,
} from "./promotionsActions";

const PROMOTIONS_INITIAL_STATE = {
  companyFeaturedLogos: [],
  sponsoredJobs: [],
};

export default function promotionsReducer(
  state = PROMOTIONS_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_COMPANY_FEATURED_LOGOS:
      return {
        ...state,
        companyFeaturedLogos: payload,
      };
    case FETCH_PROMOTED_SPONSORED_JOBS:
      return {
        ...state,
        sponsoredJobs: payload,
      };
    default:
      return state;
  }
}
